<ng-template #fullscreenTemplate>
  <div class="fixed-gallery-overlay is-manual-fullscreen" 
       (swipeleft)="onSwipeLeft()" 
       (swiperight)="onSwipeRight()">
    <div class="hero-viewport">
      <button mat-icon-button class="close-fullscreen-btn" (click)="closeManualFullscreen()">
        <mat-icon>close</mat-icon>
      </button>

      <img [src]="currentImage?.imageUrl" 
           [alt]="currentImage?.description || 'Property image'" 
           class="main-hero-img">

      <div class="dot-indicators" *ngIf="images.length > 1">
        <span *ngFor="let img of images; let i = index" 
              class="dot" 
              [class.active]="i === selectedIndex"
              (click)="selectImage(i)"> </span>
      </div>
    </div>
    <div class="thumbnail-scroller" *ngIf="images.length > 1">
      <div *ngFor="let img of images; let i = index" 
          class="thumb-item" 
          [class.selected-thumb]="i === selectedIndex"
          (click)="selectImage(i)">
        <img [src]="img.imageUrl" class="thumb-img" alt="Property image thumbnail">
      </div>
    </div>
  </div>
</ng-template>

<div class="gallery-container" #galleryContainer>
  <div class="hero-viewport" (click)="openManualFullscreen()" (swipeleft)="onSwipeLeft()" (swiperight)="onSwipeRight()">
     <img [src]="currentImage?.imageUrl" class="main-hero-img" alt="property main image">

     <div class="dot-indicators" *ngIf="images.length > 1">
      <span *ngFor="let img of images; let i = index" 
            class="dot" [class.active]="i === selectedIndex"
            (click)="selectImage(i); $event.stopPropagation()"></span>
    </div>

     <button matIconButton class="fullscreen-btn">
        <mat-icon>fullscreen</mat-icon>
     </button>
  </div>

  <div class="thumbnail-scroller" *ngIf="images.length > 1">
    <div *ngFor="let img of images; let i = index" 
         class="thumb-item" 
         [class.selected-thumb]="i === selectedIndex"
         (click)="selectImage(i)">
      <img [src]="img.imageUrl" class="thumb-img" alt="property image thumbnail">
    </div>
  </div>
</div>